import { render, staticRenderFns } from "./wfList.vue?vue&type=template&id=44e2b9bc&scoped=true&"
import script from "./wfList.vue?vue&type=script&lang=js&"
export * from "./wfList.vue?vue&type=script&lang=js&"
import style0 from "./wfList.vue?vue&type=style&index=0&id=44e2b9bc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44e2b9bc",
  null
  
)

export default component.exports